import { Component, OnInit,Renderer2,ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { StmgService } from 'src/app/services/state_Management/stmg.service';
import { StorageServicesService } from 'src/app/services/storage_services/storage-services.service';
import { SelectionInfoComponent } from '../../../modals/selection-info/selection-info.component';
//import { nextTenbetCategories } from './next-ten-bet-catogories ';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-next-ten',
  templateUrl: './next-ten.component.html',
  styleUrls: ['./next-ten.component.scss'],
})
export class NextTenComponent implements OnInit {

  betCat: any = [];
  allCategories: any = [];
  selectedBetCategory:any;
  selectedLanguage: any;

  constructor(
    private router: Router, 
    public modalController: ModalController,
    public renderer:Renderer2,
    public ele:ElementRef,
    private stmgService: StmgService,
    private storageService: StorageServicesService,
    public translate:TranslateService,
    ) {}
  
  ngOnInit() {
    this.stmgService.language_status.subscribe(message => {
      this.translate.get('BET_CATEGORIES').subscribe((res: string) => {
        let index=0;
        this.categories.forEach(ele=>{
            this.categories[index].name=res[index]
            index++
        })
        this.getBetCategories();
    });
      
    });

    // select initial category as 'All Races'
    this.selectedBetCategory = this.allCategories[0];
    //load new data when main nav bar clicked
    this.stmgService.next10Refresh_status.subscribe(message =>{
      this.getBetCategories();
      this.selectedBetCategory = this.allCategories[0];
    });

  }

  // get Bet Categories 
  getBetCategories(){    
    for (let i = 0; i < this.categories.length; i++) {
      this.allCategories[i] = {
        name: this.categories[i].name,
        image: this.categories[i].image,
        filter: this.categories[i].filter,
        country: this.categories[i].country,
        inplay: this.categories[i].inplay,
        active:this.categories[i].active,
        sport:this.categories[i].sport
      };
    }
  } 


  // open selection block 
  viewRaceDetails() {
    this.router.navigate(['/race_details'])
  }


  // open meeting info popup
  async viewInfoDetails() {
    const modal = await this.modalController.create({
      component: SelectionInfoComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }


  // next10 sport categories
  switch_SportCategories(item:any,event:any){
    if(this.selectedBetCategory==item){
      this.stmgService.nav2Next10Refresh('yes');
    }else{
      this.selectedBetCategory = item;
      let myTag = this.ele.nativeElement.querySelectorAll("a");
      myTag.forEach(ele=>{
        ele.classList.remove('active');
      })

      //set secondary nav bar active color
      if(event.target.id=="aTag"){
        this.renderer.addClass(event.target, 'active');
      }else{
        this.renderer.addClass(event.target.parentNode, 'active');
      }
    }
    
  }


  categories  = [
    {
        filter: 1,
        country:'AL',
        image: '../../../assets/images/horse.png',
        inplay: false,
        name: "All Races",
        active:true,
        sport:'RC'
    },
    {
        filter: 1,
        country:'UK',
        image: '../../../assets/images/uk.png',
        inplay: false,
        name: 'UK Racing"',
        active:false,
        sport:'HR'
    },
    {
        filter: 1,
        country:'UK',
        image: '../../../assets/images/uk.png',
        inplay: false,
        name: 'UK Greyhounds',
        active:false,
        sport:'DG'
    },
    {
        filter: 1,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Racing',
        active:false,
        sport:'HR'
    },
    {
        filter: 1,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Greyhounds',
        active:false,
        sport:'DG'
    },
    {
        filter: 1,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Harness',
        active:false,
        sport:'HA'
    },
    {
        filter: 1,
        country:'FR',
        image: '../../../assets/images/france.png',
        inplay: false,
        name: 'France Racing',
        active:false,
        sport:'HR'
    },
    {
        filter: 1,
        country:'DEU',
        image: '../../../assets/images/germany.png',
        inplay: false,
        name: 'Germany Racing',
        active:false,
        sport:'HR'
    },
];



  
}
